import Styles from './CertScheduleForm.module.scss';
import { useState, useContext, useEffect } from 'react';
// Module imports.
import { Backdrop, TextField, FormControl, Autocomplete, FormHelperText } from '@mui/material';
import axios from 'axios';
// Components import.
import { ViewContext, useAPI, AuthContext, useTranslation } from 'components/lib';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

export function CertScheduleForm({ message, label, showCard, setShowCard, userId, setUserId, dataAPI, endpoint, ...props }) {

    const { t } = useTranslation();
    const viewContext = useContext(ViewContext);
    const Event = require('components/lib').Event;
    const context = useContext(AuthContext);
    const [selectedCerts, setSelectedCerts] = useState([])
    const [selectedDate, setSelectedDate] = useState('')
    const [dateValid, setDateValid] = useState(true)
    const { data: certs, loading } = useAPI(dataAPI, 'GET');
    const handleChange = (event, values) => {
        setSelectedCerts(values);
    };

    const handleDateInput = (inputValue) => {
        const [day, month, year] = inputValue.split('-');
        const inputDate = new Date(`${year}-${month}-${day}`);

        const isDateValid = /^(\d{2})-(\d{2})-(\d{4})$/.test(inputValue) &&
            !isNaN(inputDate) &&
            inputDate >= new Date();

        setDateValid(isDateValid);
        setSelectedDate(inputValue);
    };

    useEffect(() => {
        if (selectedCerts.length === 1 && selectedCerts[0]?.due_date) {
            setSelectedDate(selectedCerts[0]?.due_date)
            setDateValid(true)
        }

    }, [selectedCerts])

    const closeForm = () => {
        setShowCard(false); setUserId()
    }


    const updateDueDate = async () => {
        const [day, month, year] = selectedDate.split('-');
        const inputDate = new Date(`${year}-${month}-${day}`);

        const isDateValid = /^(\d{2})-(\d{2})-(\d{4})$/.test(selectedDate) &&
            !isNaN(inputDate) &&
            inputDate >= new Date();

        if (!isDateValid) {
            viewContext.notification.show(t('dashboard.dueDateScheduleForm.notification.invalidDate'), 'error', false);
            setDateValid(isDateValid);
            setSelectedDate();
            return;
        }

        const data = {
            selectedCerts: selectedCerts,
            due_date: selectedDate
        }
        const options = {
            method: 'PATCH',
            url: endpoint,
            data: data,
        };
        await axios.request(options)
            .then(function (response) {
                Event('assigned_due_date', context.user.account_id);
                closeForm();
                viewContext.notification.show(t('dashboard.dueDateScheduleForm.notification.success'), 'success', false);
            })
            .catch((err) => {
                viewContext.notification.show(t('dashboard.dueDateScheduleForm.notification.error'), 'error', true);
            });
    }


    return (
        <>
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1
                }}
                open={showCard}
                invisible={!showCard}
            >
                {loading ? (
                    <LoadingBackdrop isOpen={true} />
                ) : (
                    <div id='formContainer' className={Styles.formContainer}>
                        <p className={Styles.formTitle}>
                            {t('dashboard.dueDateScheduleForm.title')}
                        </p>
                        <div id='inputContainer' className={Styles.inputContainer}>
                            <p style={{ fontSize: "0.7em", marginBottom: '0.5em' }}>
                                {message}
                            </p>
                            <FormControl
                                fullWidth
                                sx={{ marginBottom: '0.5em' }}
                            >
                                <Autocomplete
                                    id="certs-select"
                                    multiple
                                    // limitTags={5}
                                    options={certs || []}
                                    value={selectedCerts || []}
                                    onChange={handleChange}
                                    renderInput={(params) => (
                                        <TextField {...params} label={label} fullWidth />
                                    )}
                                    isOptionEqualToValue={(option, value) =>
                                        option.name === value.name
                                    }
                                    getOptionLabel={(option) => option.name}
                                />

                                <FormHelperText>
                                    {certs?.length ? t('dashboard.dueDateScheduleForm.helperText.enrolled') :
                                        t('dashboard.dueDateScheduleForm.helperText.notEnrolled')}
                                </FormHelperText>
                            </FormControl>
                            <TextField
                                fullWidth
                                InputProps={{
                                    readOnly: !certs?.length || !selectedCerts.length,
                                    maxLength: 10
                                }}
                                error={!dateValid}
                                id="due-date"
                                label={t('dashboard.dueDateScheduleForm.date.label')}
                                placeholder="DD-MM-YYYY"
                                helperText={!dateValid ? t('dashboard.dueDateScheduleForm.date.warning') : ' '}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={selectedDate || ''}
                                onChange={(e) => handleDateInput(e.target.value)}
                            />
                        </div>
                        <div id='buttonContainer' className={Styles.buttonContainer}>
                            <button
                                id='cancelButton'
                                className={Styles.cancelButton}
                                onClick={closeForm}
                            >
                                {t('dashboard.dueDateScheduleForm.button.close')}
                            </button>
                            <button
                                id='saveButton'
                                className={Styles.saveButton}
                                onClick={updateDueDate}
                                disabled={!dateValid}
                            >
                                {t('dashboard.dueDateScheduleForm.button.update')}
                            </button>
                        </div>
                    </div>
                )}
            </Backdrop></>
    )
}